import {
   CONTAINER_LAYOUT_TYPE_LIST, JUSTIFY_OPTIONS,
   parseLength, formatLength, defaultJustifyFor,
} from '../variables/containerLayoutTypes';

// Shared layout-config editor used by both courses/TopicContainerCard.jsx
// and exercise-templates/ContainerCard.jsx - previously duplicated inline
// in both, now one implementation so the two container systems can't drift
// visually or behaviorally. `layoutKey`/`config` are the container's
// current values; `onLayoutChange(key)` / `onConfigChange(nextConfig)` are
// the caller's own save handlers (each already knows how to PUT its own
// entity type).
export default function ContainerConfigForm({ layoutKey, config, onLayoutChange, onConfigChange }) {
   const supportsJustify = layoutKey === 'wrap' || layoutKey === 'flex_row';
   const justify = config.justify || defaultJustifyFor(layoutKey);

   const lengthFields = layoutKey === 'wrap'
      ? [{ key: 'minItemWidth', label: 'Мін. ширина', allowEmpty: false }, { key: 'gap', label: 'Відступ', allowEmpty: false }]
      : layoutKey === 'flex_row'
         ? [{ key: 'gap', label: 'Відступ', allowEmpty: false }, { key: 'itemWidth', label: 'Ширина картки', allowEmpty: true }]
         : [{ key: 'gap', label: 'Відступ', allowEmpty: false }];

   const handleLengthChange = (field, rawNumber, unit, allowEmpty) => {
      if (rawNumber === '' && allowEmpty) {
         onConfigChange({ ...config, [field]: null });
         return;
      }
      const number = rawNumber === '' ? 0 : Number(rawNumber);
      onConfigChange({ ...config, [field]: formatLength(number, unit) });
   };

   return (
      <div className='topic-container-config-form'>
         <div className='topic-container-layout-picker'>
            {CONTAINER_LAYOUT_TYPE_LIST.map((lt) => (
               <div key={lt.key} className={'topic-container-layout-chip' + (lt.key === layoutKey ? ' active' : '')}
                  onClick={() => onLayoutChange(lt.key)}>
                  {lt.label}
               </div>
            ))}
         </div>

         <div className='topic-container-config-fields'>
            {(layoutKey === 'grid' || layoutKey === 'table') ? (
               <label className='topic-container-config-field'>
                  Колонки
                  <input type='number' min='1' max='6' className='submit-field from-input txt-c'
                     value={config.columns ?? ''}
                     onChange={(e) => onConfigChange({ ...config, columns: e.target.value === '' ? null : Number(e.target.value) })} />
               </label>
            ) : ''}

            {lengthFields.map((field) => {
               const { number, unit } = parseLength(config[field.key], field.allowEmpty ? null : 0);
               return (
                  <label key={field.key} className='topic-container-config-field'>
                     {field.label}
                     <div className='topic-container-length-input'>
                        <input type='number' className='submit-field from-input txt-c'
                           value={number ?? ''} placeholder={field.allowEmpty ? 'авто' : ''}
                           onChange={(e) => handleLengthChange(field.key, e.target.value, unit, field.allowEmpty)} />
                        <div className='topic-container-unit-toggle'>
                           <span className={unit === 'px' ? 'active' : ''} onClick={() => handleLengthChange(field.key, number ?? 0, 'px', field.allowEmpty)}>px</span>
                           <span className={unit === '%' ? 'active' : ''} onClick={() => handleLengthChange(field.key, number ?? 0, '%', field.allowEmpty)}>%</span>
                        </div>
                     </div>
                  </label>
               );
            })}
         </div>

         {supportsJustify ? (
            <label className='topic-container-config-field topic-container-config-field-wide'>
               Вирівнювання
               <div className='topic-container-layout-picker'>
                  {JUSTIFY_OPTIONS.map((opt) => (
                     <div key={opt.key} className={'topic-container-layout-chip' + (justify === opt.key ? ' active' : '')}
                        onClick={() => onConfigChange({ ...config, justify: opt.key })}>
                        {opt.label}
                     </div>
                  ))}
               </div>
            </label>
         ) : ''}
      </div>
   );
}
